import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import Keycloak from 'keycloak-js';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean | UrlTree> => {
  const { authenticated, grantedRoles } = authData;

  const requiredRole = route.data['role'];

  if (authenticated) {
    return true;
  }

  const keycloak = inject(Keycloak);
  await keycloak.login({
    redirectUri: window.location.origin + _.url,
  });

  return false;
};
export const authGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);
